import type { QueryObject } from '@/shared/lib/serializeQuery';
import type { SearchCriteriaParams } from '@/shared/model';
import { toIds } from './values';

export function hotelCategories(query: QueryObject): Pick<SearchCriteriaParams, 'hotelCategories'> | null {
  const ids = toIds(query.hotelClass);

  return ids.length ? { hotelCategories: ids } : null;
}
